
<template>
  <div class="model-content" style="display: flex; justify-content: center;">
    <div class="model3" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'rtl' : ''">
      <div class="bg_img_container">
        <img style="width: 100%;" :src="moban_list.url" />
      </div>
      <div class="merchant_name">
        <div class="merchant_name_font">{{ posterList.merchant_name }}</div>
      </div>
      <div class="food_name">
        <div class="food_name_font">{{ posterList.food_name }}</div>
      </div>
      <div class="food_img">
        <img :src="posterList.food_img" alt="">
      </div>
      <div class="food_price">
        <div class="text food_price_ug" v-if="posterList.lang == 'ug' || !posterList.lang">
          <span>يۈەن</span>
        </div>
        <div class="text food_price_zh" v-if="posterList.lang == 'zh'">
          <span>元</span>
        </div>
        <div class="price">
          <span>{{ posterList.food_price }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      posterList: {},
      moban_list: {
        url: require('../../img/poster/model_11.jpg'),
      },
    };
  },
  created() {
    this.canvasfortitle(this.$route.query.merchant_name, this.$route.query.food_name, this.$route.query);
  },
  methods: {
    canvasfortitle(merchant_name, food_names, query) {
      let res_name = merchant_name.replaceAll('(', '-')
      res_name = res_name.replaceAll('（', '-')
      res_name = res_name.replaceAll(')', ' ')
      res_name = res_name.replaceAll('）', ' ')
      let food_name = food_names.replaceAll('(', '-')
      food_name = food_name.replaceAll('（', '-')
      food_name = food_name.replaceAll(')', ' ')
      food_name = food_name.replaceAll('）', ' ')
      this.posterList = query;
      this.posterList['merchant_name'] = res_name;
      this.posterList['food_name'] = food_name;
    },
  },
};
</script>

<style scoped>
.model-content {
  width: 750px;
  height: 320px;
  position: relative;
  margin: auto;
  overflow: hidden;
}

.model3 {
  width: 750px;
  height: 320px;
  position: relative;
  overflow: hidden;
}

.rtl {
  direction: rtl;
}

.bg_img_container  {
  width: 100%;
  height: 100%;
}

.merchant_name {
  position: absolute;
  right: 50px;
  top: 1px;
  width: 356px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 22px;
  padding: 8px;
  box-sizing: border-box;
}

.merchant_name_font {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
  text-align: center;
}

.food_name {
  position: absolute;
  top: 107px;
  right: 0;
  color: #fff;
  width: 448px;
  height: 70px;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 8px 20px;
  font-size: 22px;
  box-sizing: border-box;
}

.food_name_font {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
  text-align: center;
}

.food_price {
  position: absolute;
  bottom: 8px;
  right: 103px;
  width: 270px;
  height: 95px;
}

.food_price .text {
  position: absolute;
  left: 0;
  top: 0;
  width: 105px;
  height: 100%;
  font-size: 60px;
  color: #e4ff01;
  display: flex;
  justify-content: center;
  align-items: center;
}

.food_price .price {
  position: absolute;
  right: 5px;
  top: 0;
  width: 135px;
  height: 100%;
  font-size: 42px;
  font-weight: bold;
  color: #34352c;
  display: flex;
  justify-content: center;
  align-items: center;
}

.food_price_ug {
  margin-top: -10px;
}

.food_price .food_price_zh {
  font-weight: bold;
  left: 260px;
}

.food_img {
  position: absolute;
    left: -167px;
    top: -113px;
    width: 442px;
    height: 442px;
    border-radius: 50%;
    overflow: hidden;
}

.food_img img {
  width: 100%;
  height: 100%;
}
</style>